import { render, staticRenderFns } from "./HelpPopover.vue?vue&type=template&id=88d1f938"
import script from "./HelpPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpPopover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports